import * as Yup from 'yup';

export const planFormSchema = Yup.object().shape({
  planName: Yup.string().required('Print (or file) name is required'),
  // planFileTypeID: Yup.string().required('File type is required'),
  // uploadedFile: Yup.mixed().when('extension', {
  //   is: (extension: any) => !!extension, // If an extension is selected
  //   then: (schema) => schema.required('File upload is required'),
  //   otherwise: (schema) => schema.notRequired(),
  // }),
});
